<template>
  <div v-if="status === 'true'">
    <div id="box-container">
      <div class='boxes box1'></div>
      <div class='boxes box2'></div>
      <div class='boxes box3'></div>
    </div>
    <div class="text  ">
       <h6 class="mt-2" >گروه فناوری اطلاعات هلو</h6>
    </div>
  </div>
  <section class="vh-100 h-75 formLogin" v-else>
    <div class="container py-5 h-75">
      <div class="row   d-flex justify-content-center align-items-center h-75 ">
        <div class="col-log-8 col-xl-8  auth " >
          <div class="card " style="border-radius: 1rem; ">
            <div class="row g-0">
              <div class="col-md-6 col-lg-6 d-flex align-items-center">
                <div class="card-body p-lg-5 text-black text-center ">
                    <span>
                      <img src="@/agent/assets/images/logo400.png" style="width: 50%">
                         <p>گروه فناوری اطلاعات هلو</p>
                    </span>
                  <loginForm/>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 d-none d-md-block" style="text-align: center">
                <img src="../../assets/images/login.webp"  alt="login form" style="width: 60%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import loginForm from "@/agent/components/Login/index.vue"
import {$ref} from "vue/macros";

let status = $ref('true');
setTimeout(() => {
  status = false;
}, 1000);
</script>